import {
  Alert,
  Backdrop,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Pagination,
  PaginationItem,
  Paper,
  Snackbar,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useEffect, useState } from "react";
import React from "react";
import CustomDataGrid from "../CustomComponents/CustomDataGrid";
import { Add, ArrowBack, ArrowForward, Delete } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { FileReceiptGridReducerAction } from "../Store/FileReceiptGridReducer";
import store from "./../Store/index";
import GetBranchDetailsWithCode from "../CustomComponents/GetBranchDetailsWithCode";
import { v4 as uuid } from "uuid";
import axios from "axios";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import NoDataFound from "../CustomComponents/NoDataFound";
import { useRef } from "react";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import { FileUploadAreaAndPreviewReducerAction } from "../Store/FileUploadAreaAndPreviewReducer";
import FileUploadAreaAndPreview from "../CustomComponents/FileUploadAreaAndPreview";

const CreditAmountDetails = (props) => {
  //Importing Hooks
  const dispatch = useDispatch();
  //Selectors from redux store
  const datarows = useSelector((state) => state.fileReceiptGrid.gridRows);
  const userName = useSelector((state) => state.branch.userName);
  const initialLoad = useSelector((state) => state.fileReceiptGrid.initialLoad);
  const currentRowAppNumsArray = useSelector(
    (state) => state.fileReceiptGrid.currentRowBranchAppNums
  );
  const currentRowGlAccounts = useSelector(
    (state) => state.fileReceiptGrid.currentRowBranchGlAccounts
  );
  const voucherDateValidDateError = useSelector(
    (state) => state.fileReceiptGrid.voucherDateValidDateError
  );
  const saveRequestActive = useSelector(
    (state) => state.fileReceiptGrid.saveRequestActive
  );

  const currentReceiptCustomerData = useSelector(
    (state) => state.fileReceiptGrid.currentReceiptCustomerData
  );

  // const [datarows, setDataRows] = React.useState([]);
  const [gridColumns, setGridColumns] = React.useState([]);
  // branches with code
  const [branchNamesWithCodes, setBranchNamesWithCodes] = useState([]);

  const [deleteOperationActive, setDeleteOperationActive] =
    React.useState(false);
  // Dialog msg content.
  const [dialogMessage, setDialogMessage] = useState("");
  const [dialogTitleMessage, setDialogTitleMessage] = useState("");
  const [dialogConfirmMode, setDialogConfirmMode] = useState(false);
  //Maintainig State for Dialog while submitting the application
  const [open, setOpen] = useState(false);

  const [rows, setRows] = React.useState([]);
  const [accordianOpen, setAccordianOpen] = React.useState(true);
  const [page, setPage] = React.useState(1);
  const rowsPerPage = 10;
  const [totalPageCount, setTotalPageCount] = React.useState(0);
  const [totalRowsCount, setTotalRowsCount] = React.useState(0);

  //shortcut key
  const yesRef = useRef(null);
  const cancelRef = useRef(null);
  const deleteRowRef = useRef(null);
  const okRef = useRef(null);
  const backRef = useRef(null);
  const addRowRef = useRef(null);
  const saveRef = useRef(null);

  // save request spinner msg.
  const [saveRequestActiveSpinnerMsg, setSaveRequestActiveSpinnerMsg] =
    useState("");

  const fileUploadAreaProps = { maxFileCount: 1 };

  // AML Dialog Upload Area open
  const [AmlFileUploadAreaOpen, setAmlFileUploadAreaOpen] = useState(false);

  // max value 1200 -> mobile.
  const [deviceMode, setDeviceMode] = React.useState("");
  const deviceModeValue = useMediaQuery("(max-width:1200px)");

  //SnackBar Handler
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [snackBarState, setSnackBarState] = React.useState({
    vertical: "bottom",
    horizontal: "left",
  });
  const { vertical, horizontal } = snackBarState;
  const [alert, setAlert] = useState(false);

  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "creditAmount",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    if (event.key === "Escape" || event.keyCode === 27) {
      // on escape press close the dialog.
      if (dialogConfirmMode) {
        handleClose();
      } else {
        handleDialogClose();
      }
    }
    let charCode = String.fromCharCode(event.which).toLowerCase();
    let refList = {
      cancelRef: cancelRef,
      yesRef: yesRef,
      okRef: okRef,
      backRef: backRef,
      saveRef: saveRef,
    };
    if (event.ctrlKey) {
      if (charCode === "a") {
        addRowRef.current.click();
      } else if (charCode === "r") {
        deleteRowRef.current.click();
      } else {
        dispatch(
          CommonShortCutAction.getShortCutValue({
            event: event,
            refs: refList,
            screen: "netReceipt",
          })
        );
      }
    }
  };

  const openAlertHandler = () => {
    setAlert(true);
  };
  const closeAlertHandler = () => {
    setAlert(false);
  };

  useEffect(() => {
    // true -> mobile or tab, false -> desktop
    let SnackPosition = {
      vertical: deviceModeValue ? "top" : "bottom",
      horizontal: deviceModeValue ? "right" : "left",
    };
    setSnackBarState(SnackPosition);
  }, []);

  useEffect(() => {
    // frequency of add or delete creates a performance issue of rerender.
    setDeleteOperationActive(true);
    const branchCodes = GetBranchDetailsWithCode();
    setBranchNamesWithCodes(branchCodes);

    setDeviceMode(deviceModeValue ? "MOBILE" : "DESKTOP");
    setRows([...datarows].slice(0, 10));
    setTotalPageCount(
      datarows.length % 10 !== 0
        ? Number(Number((datarows.length / 10).toString().split(".")[0]) + 1)
        : Number(Number((datarows.length / 10).toFixed()))
    );
    setTotalRowsCount(datarows.length);
    setPage(1);

    if (props.screenMode !== "VIEW") {
      if (props.fileReceiptState.receiptFor === "Customer ID") {
        let newcolumns = [];
        let filteredColumns = [...columns].filter(
          (col) =>
            col.field !== "branch" &&
            col.field !== "applicationNum" &&
            col.field !== "glAcc"
        );
        // add single select type branch & application num columns.
        let appNumsByCustId = [...props.appNumByCustIdBranch];
        const branchesvalues = appNumsByCustId.map((record) => record.branch);
        newcolumns.push({
          field: "branch",
          headerName: "Branch Name",
          headerAlign: "center",
          align: "left",
          flex: 200,
          editable: props.screenMode !== "VIEW",
          type: "singleSelect",
          valueOptions: branchesvalues,
        });
        newcolumns.push({
          field: "applicationNum",
          headerName: "Application Number",
          headerAlign: "center",
          align: "left",
          flex: 200,
          editable: props.screenMode !== "VIEW",
          type: "singleSelect",
          valueOptions: currentRowAppNumsArray,
        });
        newcolumns.push({
          field: "glAcc",
          headerName: "GL Account",
          headerAlign: "center",
          align: "left",
          flex: 200,
          editable: props.screenMode !== "VIEW",
          type: "singleSelect",
          valueOptions: currentRowGlAccounts.map(
            (record) => record.account_head + " - " + record.account_desc
          ),
        });
        newcolumns = newcolumns.concat(filteredColumns);
        setGridColumns(newcolumns);
      } else {
        let newcolumns = [];
        let filteredColumns = [...columns].filter(
          (col) =>
            col.field !== "branch" &&
            col.field !== "applicationNum" &&
            col.field !== "glAcc"
        );
        newcolumns.push({
          field: "branch",
          headerName: "Branch Name",
          headerAlign: "center",
          align: "left",
          flex: 200,
        });
        newcolumns.push({
          field: "applicationNum",
          headerName: "Application Number",
          headerAlign: "center",
          align: "left",
          flex: 200,
        });
        let glAccountData = { ...props.glAccountDataMap };
        const branchCodeValue = branchCodes.find((branch) => {
          return branch.label === props.fileReceiptState.branch;
        });

        const value = glAccountData[branchCodeValue.code];
        newcolumns.push({
          field: "glAcc",
          headerName: "GL Account",
          headerAlign: "center",
          align: "left",
          flex: 200,
          editable: props.screenMode !== "VIEW",
          type: "singleSelect",
          valueOptions: value.map(
            (record) => record.account_head + " - " + record.account_desc
          ),
        });
        newcolumns = newcolumns.concat(filteredColumns);
        setGridColumns(newcolumns);
        dispatch(
          FileReceiptGridReducerAction.updateCurrentRowBranchGlAccounts(value)
        );
      }
    } else {
      // for view mode don't render delete btn column.
      const viewModeColumns = [...columns].filter(
        (col) => col.field !== "deleteBtn"
      );
      setGridColumns(viewModeColumns);
    }
    if (props.screenMode === "CREATE" && initialLoad && datarows.length === 0) {
      gridRowAddButtonHandler();
      dispatch(FileReceiptGridReducerAction.updateInitialLoad(false));
    }
    setTimeout(() => {
      // frequency of add or delete creates a performance issue of rerender.
      setDeleteOperationActive(false);
    }, 500);
  }, [
    datarows,
    props,
    currentRowAppNumsArray,
    currentRowGlAccounts,
    dialogConfirmMode,
  ]);

  const columns = [
    {
      field: "branch",
      headerName: "Branch Name",
      headerAlign: "center",
      align: "left",
      flex: 200,
    },
    {
      field: "applicationNum",
      headerName: "Application Number",
      headerAlign: "center",
      align: "left",
      flex: 200,
    },
    // {
    //   field: "disbStatus",
    //   headerName: "Disbursement Status",
    //   headerAlign: "center",
    //   align: "left",
    //   flex: 200,
    // },
    {
      field: "glAcc",
      headerName: "GL Account",
      headerAlign: "center",
      align: "left",
      flex: 200,
    },
    {
      field: "glAccDesc",
      headerName: "GL Account Desc",
      headerAlign: "center",
      align: "left",
      flex: 200,
    },
    {
      field: "creditAmt",
      headerName: "Credit Amount",
      headerAlign: "center",
      align: "right",
      type: "number",
      flex: 190,
      editable: props.screenMode !== "VIEW",
      renderCell: (params) => {
        let value =
          params.value === undefined ||
          params.value === null ||
          params.value === "" ||
          params.value === "0"
            ? 0
            : Number(params.value) <= 0
            ? 0
            : parseInt(params.value).toLocaleString("en-IN");
        return value;
      },
    },
    {
      field: "deleteBtn",
      headerName: "",
      headerAlign: "center",
      align: "center",
      flex: 100,
      renderCell: (params) => {
        return (
          <Tooltip title="Delete">
            <Delete
              disabled={props.screenMode !== "CREATE"}
              fontSize="small"
              sx={{ color: "#004A92", fontWeight: 700 }}
              onClick={() => {
                deleteSelectedRow(params);
              }}
            ></Delete>
          </Tooltip>
        );
      },
    },
  ];

  //Delete Button Handler
  const deleteSelectedRow = (params) => {
    setDeleteOperationActive(true);
    setTimeout(() => {
      // get the latest records.
      let latestRecords = store.getState().fileReceiptGrid.gridRows;
      const filteredRows = [...latestRecords].filter((data) => {
        return data.id !== params.id;
      });
      dispatch(FileReceiptGridReducerAction.updateGridRows([...filteredRows]));
      setTimeout(() => {
        setDeleteOperationActive(false);
      }, 1000);
    }, 1000);
  };

  const handleOnCellKeyDown = (params, event) => {
    if (params.field === "creditAmt") {
      setDeleteOperationActive(true);
      const rowDataIndex = [...datarows].findIndex((data) => {
        return data.id === params.id;
      });

      let activeRecord = datarows[rowDataIndex];
      const updatedRecord = {
        ...activeRecord,
        creditAmt:
          event.target.value <= 0 || Number(event.target.value) > 99999999
            ? 0
            : Math.floor(event.target.value),
      };
      let newItems = [...datarows];
      newItems[rowDataIndex] = updatedRecord;
      dispatch(FileReceiptGridReducerAction.updateGridRows([...newItems]));
      if (Number(event.target.value) > 99999999) {
        setMessage("Credit Amount can't be greater than 9,99,99,999.");
        setAlertType("error");
        openAlertHandler();
      } else if (String(event.target.value).includes(".")) {
        setMessage("Decimal Value not Acceptable in Credit Amount.");
        setAlertType("error");
        openAlertHandler();
      }
      setTimeout(() => {
        setDeleteOperationActive(false);
      }, 1000);
    }
  };

  const cellDoubleClickHandler = (params) => {
    const rowDataIndex = [...datarows].findIndex((data) => {
      return data.id === params.id;
    });

    let activeRecord = datarows[rowDataIndex];
    if (
      params.field === "applicationNum" &&
      activeRecord.branch !== null &&
      activeRecord.branch !== undefined &&
      activeRecord.branch !== ""
    ) {
      let appNumsByCustId = [...props.appNumByCustIdBranch];
      const branchBasedAppNums = [];
      appNumsByCustId
        .filter((record) => record.branch === activeRecord.branch)
        .forEach((record) => {
          const closedLoanAppNums = record.closedAppNum;
          // remove the closed applications not to load.
          if (props.screenMode === "CREATE") {
            record.applicationNum
              .filter((value) => !closedLoanAppNums.includes(value))
              .forEach((appNum) => {
                branchBasedAppNums.push(appNum);
              });
          } else {
            // view or modify mode.
            record.applicationNum.forEach((appNum) => {
              branchBasedAppNums.push(appNum);
            });
          }
        });
      dispatch(
        FileReceiptGridReducerAction.updateCurrentRowAppBranch(
          activeRecord.branch
        )
      );
      dispatch(
        FileReceiptGridReducerAction.updateCurrentRowBranchAppNums(
          branchBasedAppNums
        )
      );
    }
    if (
      params.field === "glAcc" &&
      activeRecord.branch !== null &&
      activeRecord.branch !== undefined &&
      activeRecord.branch !== ""
    ) {
      let glAccountData = { ...props.glAccountDataMap };
      const branchCodeValue = branchNamesWithCodes.find((branch) => {
        return branch.label === activeRecord.branch;
      });

      const value = glAccountData[branchCodeValue.code];
      dispatch(
        FileReceiptGridReducerAction.updateCurrentRowAppBranch(
          activeRecord.branch
        )
      );
      dispatch(
        FileReceiptGridReducerAction.updateCurrentRowBranchGlAccounts(value)
      );
    }
  };

  const handlePageChange = (event, newPage) => {
    let offset = (newPage - 1) * rowsPerPage;
    setPage(newPage);
    setRows([...datarows].slice(offset, offset + rowsPerPage));
  };

  //Cell Change Handler
  const cellChangeHandler = (params) => {
    setDeleteOperationActive(true);
    const rowDataIndex = [...datarows].findIndex((data) => {
      return data.id === params.id;
    });

    let activeRecord = datarows[rowDataIndex];
    let updatedRecords = [];

    // for application mode the branch & appnum in grid is non-editable.
    // for customer id mode the branch & appnum are single select & editable.
    if (params.field === "branch") {
      updatedRecords = [...datarows].map((row) => {
        if (row.id === activeRecord.id) {
          let recordValue = { ...row };
          recordValue.branch = params.value;
          // when set the value of branch use the value of that branch and load application nums.
          recordValue.applicationNum = "";
          let appNumsByCustId = [...props.appNumByCustIdBranch];
          const branchBasedAppNums = [];
          appNumsByCustId
            .filter((record) => record.branch === params.value)
            .forEach((record) => {
              const closedLoanAppNums = record.closedAppNum;
              // remove the closed applications not to load.
              if (props.screenMode === "CREATE") {
                record.applicationNum
                  .filter((value) => !closedLoanAppNums.includes(value))
                  .forEach((appNum) => {
                    branchBasedAppNums.push(appNum);
                  });
              } else {
                // view or modify mode.
                record.applicationNum.forEach((appNum) => {
                  branchBasedAppNums.push(appNum);
                });
              }
            });

          // branch based glaccount data.
          recordValue.glAcc = "";
          recordValue.glAccDesc = "";
          recordValue.creditAmt = "0";
          let glAccountData = { ...props.glAccountDataMap };
          const branchCodeValue = branchNamesWithCodes.find((branch) => {
            return branch.label === params.value;
          });

          const value = glAccountData[branchCodeValue.code];
          dispatch(
            FileReceiptGridReducerAction.updateCurrentRowAppBranch(params.value)
          );
          dispatch(
            FileReceiptGridReducerAction.updateCurrentRowBranchAppNums(
              branchBasedAppNums
            )
          );
          dispatch(
            FileReceiptGridReducerAction.updateCurrentRowBranchGlAccounts(value)
          );
          return recordValue;
        } else {
          return row;
        }
      });
    }

    if (params.field === "applicationNum") {
      updatedRecords = [...datarows].map((row) => {
        if (row.id === activeRecord.id) {
          let recordValue = { ...row };
          recordValue.applicationNum = params.value;
          return recordValue;
        } else {
          return row;
        }
      });
      // initially check for duplicate gl's when rows greater than 1.
      if (datarows.length > 1) {
        const duplicateExistFlag = checkForDupliateGlAccounts(
          updatedRecords,
          params,
          activeRecord
        );
        if (!duplicateExistFlag) {
          updatedRecords = [...updatedRecords].map((row) => {
            if (row.id === activeRecord.id) {
              let recordValue = { ...row };
              recordValue.applicationNum = params.value;
              return recordValue;
            } else {
              return row;
            }
          });
        } else {
          // on duplicate exist remove that.

          // updatedRecords = [...datarows].filter(
          //   (row) => row.id !== activeRecord.id
          // );

          // in case of error set the glacc & descrip to empty.
          updatedRecords = [...updatedRecords].map((row) => {
            if (row.id === activeRecord.id) {
              let recordValue = { ...row };
              recordValue.glAcc = "";
              recordValue.glAccDesc = "";
              recordValue.creditAmt = 0;
              return recordValue;
            } else {
              return row;
            }
          });
        }
      }
    }

    if (params.field === "glAcc") {
      // update the records first then we can validate & remove current active row.
      updatedRecords = [...datarows].map((row) => {
        if (row.id === activeRecord.id) {
          let recordValue = { ...row };
          const glAccountValue = currentRowGlAccounts.filter(
            (record) =>
              record.account_head + " - " + record.account_desc === params.value
          );
          recordValue.glAcc = glAccountValue[0]?.account_head;
          recordValue.glAccDesc = glAccountValue[0]?.account_desc;
          return recordValue;
        } else {
          return row;
        }
      });
      updatedRecords = checkForDupliateGlAccounts(
        updatedRecords,
        params,
        activeRecord
      );
    }

    if (params.field === "creditAmt") {
      let invalidAmtExist = false;
      updatedRecords = [...datarows].map((row) => {
        if (row.id === activeRecord.id) {
          let recordValue = { ...row };
          recordValue.creditAmt = Math.floor(
            Number(params.value) <= 0 || Number(params.value) > 99999999
              ? 0
              : params.value
          );
          if (Number(params.value) > 99999999) {
            invalidAmtExist = true;
          }
          return recordValue;
        } else {
          return row;
        }
      });
      if (invalidAmtExist) {
        setMessage(
          "Credit Amount can't be greater than 9,99,99,999  so reset to default value Zero."
        );
        setAlertType("error");
        openAlertHandler();
      } else if (String(params.value).includes(".")) {
        setMessage("Decimal Value not Acceptable in Credit Amount.");
        setAlertType("error");
        openAlertHandler();
      }
    }
    dispatch(FileReceiptGridReducerAction.updateGridRows([...updatedRecords]));
    setTimeout(() => {
      setDeleteOperationActive(false);
    }, 1000);
  };

  const checkForDupliateGlAccounts = (updatedRecords, params, activeRecord) => {
    let duplicateExistFlag = false;
    if (props.fileReceiptState.receiptFor === "Customer ID") {
      const appNums = [...updatedRecords].map(
        (record) => record.applicationNum
      );
      // now get the records of same appnum and check for duplicate gl accounts for application num.
      // validation of Gl accounts.
      let totalGls = [];
      for (let index = 0; index < appNums.length; index++) {
        const appNum = appNums[index];
        let duplicateGLs = [];
        if (params.field === "glAcc") {
          duplicateGLs = [...updatedRecords].filter(
            (row) =>
              row.applicationNum === appNum &&
              row.glAcc === String(params.value).split(" - ")[0]
          );

          if (duplicateGLs.length > 1) {
            totalGls =
              JSON.stringify(totalGls) !== JSON.stringify(duplicateGLs)
                ? totalGls.concat(duplicateGLs)
                : totalGls;
          }
        } else {
          // when field was application Num.
          let existGls = [];
          const filteredRecords = [...updatedRecords].filter(
            (row) =>
              row.applicationNum === appNum &&
              row.glAcc !== null &&
              row.glAcc !== undefined &&
              row.glAcc !== ""
          );
          filteredRecords.forEach((rec) => {
            if (!existGls.includes(rec.glAcc)) {
              existGls.push(rec.glAcc);
            }
          });

          if (filteredRecords.length !== existGls.length) {
            duplicateGLs = filteredRecords;
          }

          if (duplicateGLs.length > 0) {
            totalGls =
              JSON.stringify(totalGls) !== JSON.stringify(duplicateGLs)
                ? totalGls.concat(duplicateGLs)
                : totalGls;
          }
        }
      }

      if (totalGls.length === 0) {
        updatedRecords = [...updatedRecords].map((row) => {
          if (row.id === activeRecord.id && params.field === "glAcc") {
            let recordValue = { ...row };
            let glAccountData = { ...props.glAccountDataMap };
            const branchCodeValue = branchNamesWithCodes.find((branch) => {
              return branch.label === recordValue.branch;
            });

            const value = glAccountData[branchCodeValue.code];
            const glAccountValue = value.filter(
              (record) =>
                record.account_head + " - " + record.account_desc ===
                params.value
            );
            recordValue.glAcc = glAccountValue[0]?.account_head;
            recordValue.glAccDesc = glAccountValue[0]?.account_desc;
            return recordValue;
          } else {
            return row;
          }
        });
      } else {
        // updatedRecords = [...datarows].filter(
        //   (row) => row.id !== activeRecord.id
        // );

        // in case of error set the glacc & descrip to empty.
        updatedRecords = [...updatedRecords].map((row) => {
          if (row.id === activeRecord.id) {
            let recordValue = { ...row };
            recordValue.glAcc = "";
            recordValue.glAccDesc = "";
            recordValue.creditAmt = 0;
            return recordValue;
          } else {
            return row;
          }
        });
        setMessage(
          "Duplicate GL Accounts can't be added for same Application Number. Please edit the amount if needed on existing row."
        );
        setAlertType("error");
        openAlertHandler();
        duplicateExistFlag = true;
      }
    } else {
      // validation of gl accounts
      const duplicateGLs = [...datarows].filter(
        (row) => row.glAcc === String(params.value).split(" - ")[0]
      );
      if (duplicateGLs.length === 0) {
        updatedRecords = [...datarows].map((row) => {
          if (row.id === activeRecord.id && params.field === "glAcc") {
            let recordValue = { ...row };
            let glAccountData = { ...props.glAccountDataMap };
            const branchCodeValue = branchNamesWithCodes.find((branch) => {
              return branch.label === recordValue.branch;
            });

            const value = glAccountData[branchCodeValue.code];
            const glAccountValue = value.filter(
              (record) =>
                record.account_head + " - " + record.account_desc ===
                params.value
            );
            recordValue.glAcc = glAccountValue[0]?.account_head;
            recordValue.glAccDesc = glAccountValue[0]?.account_desc;
            return recordValue;
          } else {
            return row;
          }
        });
      } else {
        // updatedRecords = [...datarows].filter(
        //   (row) => row.id !== activeRecord.id
        // );

        // in case of error set the glacc & descrip to empty.
        updatedRecords = [...updatedRecords].map((row) => {
          if (row.id === activeRecord.id) {
            let recordValue = { ...row };
            recordValue.glAcc = "";
            recordValue.glAccDesc = "";
            recordValue.creditAmt = 0;
            return recordValue;
          } else {
            return row;
          }
        });

        setMessage(
          "Duplicate GL Accounts can't be added. Please edit the amount if needed on existing row."
        );
        setAlertType("error");
        openAlertHandler();
        duplicateExistFlag = true;
      }
    }
    return params.field === "glAcc" ? updatedRecords : duplicateExistFlag;
  };

  const gridRowAddButtonHandler = () => {
    setDeleteOperationActive(true);
    setTimeout(() => {
      let latestRecords = [...store.getState().fileReceiptGrid.gridRows];
      let newrecord = {};
      newrecord.id =
        Math.floor(Math.random() * 100 * Math.random()) + "-" + uuid();
      if (props.fileReceiptState.receiptFor === "Customer ID") {
        newrecord.branch = "";
        newrecord.applicationNum = "";
        newrecord.disbStatus = "";
        dispatch(
          FileReceiptGridReducerAction.updateCurrentRowBranchAppNums([])
        );
      } else {
        newrecord.branch = props.fileReceiptState.branch;
        newrecord.applicationNum =
          props.screenMode === "CREATE"
            ? props.fileReceiptState.applicationNum
            : props.fileReceiptState.applicationNum[0];
        newrecord.disbStatus = props.fileReceiptState.disbStatus;
      }

      newrecord.glAccDesc = "";
      newrecord.glAcc = "";
      newrecord.creditAmt = "0";
      latestRecords.push(newrecord);
      dispatch(FileReceiptGridReducerAction.updateGridRows([...latestRecords]));
      setTimeout(() => {
        setDeleteOperationActive(false);
      }, 1000);
    }, 1000);
  };

  const onSaveBtnClickHandler = async () => {
    // sum of rows greater than total receipt amt.
    // get the latest records from store.
    const latestRecords = store.getState().fileReceiptGrid.gridRows;
    const sumTotalCreditAmount = Number(
      [...latestRecords]
        .map((row) => Number(row.creditAmt))
        .reduce((a, b) => a + b)
    );
    let receiptData = { ...props.fileReceiptState };
    // check for if any of the rows gl account not selected before save.
    const nonGLAccSelectedRows = [...latestRecords].filter(
      (row) => row.glAcc === "" || row.glAcc === null || row.glAcc === undefined
    );

    // cash handling charge gl account should be present when receipt is cash mode.
    if (receiptData.receiptType === "CASH" && props.cashHandlingGlAccCode) {
      const cashHandlingGlExist = [...latestRecords].filter(
        (row) => row.glAcc === props.cashHandlingGlAccCode
      );
      if (cashHandlingGlExist.length === 0) {
        setMessage(
          "Cash Handling Gl Account is required for CASH Receipt Type."
        );
        setAlertType("error");
        openAlertHandler();
        return;
      } else {
        // validate the credit amount on row should be equal to cash handling charge.
        const sumTotalCreditAmountForCashGLAccount = Number(
          [...cashHandlingGlExist]
            .map((row) => Number(row.creditAmt))
            .reduce((a, b) => a + b)
        );
        if (
          sumTotalCreditAmountForCashGLAccount !==
          Number(receiptData.cashHandleCharge)
        ) {
          setMessage(
            "Sum of Credit amount of Cash Handling Gl Accounts is not equal to Cash Handling Charge :  " +
              receiptData.cashHandleCharge
          );
          setAlertType("error");
          openAlertHandler();
          return;
        }
      }
    }

    // check for if any of the rows credit amount is zero -> it is considered as dummy when value is zero for save.
    const zeroCreditAmtRows = [...latestRecords].filter((row) =>
      receiptData.receiptType !== "CASH"
        ? Number(row.creditAmt) === 0
        : Number(row.creditAmt) === 0 &&
          row.glAcc !== props.cashHandlingGlAccCode
    );

    if (nonGLAccSelectedRows.length > 0) {
      setMessage("Some rows doesn't have GL Account Data.");
      setAlertType("error");
      openAlertHandler();
      return;
    }

    if (zeroCreditAmtRows.length > 0) {
      setMessage("Some rows have Zero Credit Amount Values.");
      setAlertType("error");
      openAlertHandler();
      return;
    }
    // check for if any of the rows credit amount contains decimal point values -> then don't allow save.
    const decimalAmtRows = [...latestRecords].filter((row) =>
      String(row.creditAmt).includes(".")
    );

    if (decimalAmtRows.length > 0) {
      setMessage("Some rows have Decimal Credit Amount Values.");
      setAlertType("error");
      openAlertHandler();
      return;
    }

    let duplicateChequeNumExist = false;
    try {
      // validate for the duplicate Cheque Number.
      if (
        props.screenMode === "CREATE" &&
        receiptData.receiptType === "CHEQUE"
      ) {
        dispatch(
          FileReceiptGridReducerAction.updateDuplicateChequeNumHasError(false)
        );
        dispatch(
          FileReceiptGridReducerAction.updateDuplicateChequeNumErrorMsg("")
        );
        if (
          String(receiptData.chequeNum).length <= 6 &&
          receiptData.chequeNum !== "" &&
          receiptData.chequeNum !== null &&
          receiptData.chequeNum !== undefined
        ) {
          const value = receiptData.chequeNum;
          const appNums = new Set(
            latestRecords.map((record) => record.applicationNum)
          );
          const response = await axios.post(
            "/filereceipt/chequeNumberDuplicateCheck",
            {
              chequeNum: value,
              applicationList: [...appNums],
            }
          );
          if (response.status === 206) {
            dispatch(
              FileReceiptGridReducerAction.updateDuplicateChequeNumHasError(
                true
              )
            );
            dispatch(
              FileReceiptGridReducerAction.updateDuplicateChequeNumErrorMsg(
                response.data
              )
            );
            duplicateChequeNumExist = true;
            setMessage(response.data);
            setAlertType("error");
            openAlertHandler();
          } else {
            dispatch(
              FileReceiptGridReducerAction.updateDuplicateChequeNumHasError(
                false
              )
            );
            dispatch(
              FileReceiptGridReducerAction.updateDuplicateChequeNumErrorMsg("")
            );
          }
        }
      }
    } catch (error) {
      console.log(error);
      setMessage(
        "Cheque Num Duplication Check API Error : " + error.response.data.error
      );
      setAlertType("error");
      openAlertHandler();
      throw Error(error);
    }

    if (
      sumTotalCreditAmount === Number(receiptData.totalReceiptAmt) &&
      sumTotalCreditAmount !== 0
    ) {
      // when all conditions are ok now checking the duplicate cheque num flag before open dialog.
      if (duplicateChequeNumExist) {
        // switch back to the 1'st tab
        setTimeout(() => {
          props.handleTabChange("1");
          return;
        }, 3500);
      } else {
        // false means no duplicate check exist from backend validation.
        const isValid = await validateDisbursementStatus(receiptData);
        if(!isValid){
          setAlertType("error");
            setMessage('Unable to proceed due to disbursement is in Requested/Partial Approval State');
            openAlertHandler();
        }else{
          const msg =
            props.screenMode === "CREATE"
              ? "Want to Create Receipt?"
              : "Want to Update Receipt ?";
          setDialogTitleMessage("Confirmation");
          setDialogMessage(msg);
          setDialogConfirmMode(true);
          setTimeout(() => {
            handleClickOpen();
          }, 1000);
        }
      }
    } else {
      let zeroflag = sumTotalCreditAmount === 0;
      let errorMessage = zeroflag
        ? "Sum of Credit amount can't be zero."
        : sumTotalCreditAmount < Number(receiptData.totalReceiptAmt)
        ? "Sum of Credit amount can't be less than Total Receipt Amount :  " +
          receiptData.totalReceiptAmt
        : "Sum of Credit amount can't be greater than Total Receipt Amount :  " +
          receiptData.totalReceiptAmt;
      setMessage(errorMessage);
      setAlertType("error");
      openAlertHandler();
    }
  };

  //Handling Dailog method
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setTimeout(() => {
      setDialogConfirmMode(false);
      setOpen(false);
    }, 100);
  };

  const handleDialogClose = () => {
    handleClose();
    setTimeout(() => {
      if (!dialogConfirmMode) {
        resetValues();
      }
    }, 1000);
  };

  const resetValues = () => {
    // reset to initial state.
    props.dispatch({
      type: "resetInitialState",
      value: null,
    });
  };

  const handleOk = () => {
    if (dialogConfirmMode) {
      setOpen(false);
      setDialogConfirmMode(false);
      handleDialogClose();
      setTimeout(() => {
        SendData();
      }, 300);
    } else {
      setOpen(false);
      setDialogConfirmMode(false);
      handleDialogClose();
    }
  };

  const saveRequestPayloadFormation = () => {
    let receiptData = { ...props.fileReceiptState };
    // get the latest records from the store.
    const latestRecords = store.getState().fileReceiptGrid.gridRows;
    let gridRowsData = [...latestRecords].map((record) => {
      let recordValue = { ...record };
      const branchCodeValue = props.branchNamesWithCodes.find((branch) => {
        return branch.label === recordValue.branch;
      });
      recordValue.branchCode = branchCodeValue.code;
      return recordValue;
    });
    receiptData.favourList = [...gridRowsData];
    receiptData.screenMode = props.screenMode;
    // update the customer Id for Receipt For Application.
    if (receiptData.receiptFor === "Application Number") {
      const currentCustomerData = { ...currentReceiptCustomerData };
      receiptData.customerId = currentCustomerData.customerId;
    }
    receiptData.createdBy = userName;
    receiptData.lastModifiedBy = userName;
    if (
      receiptData.receiptType === "Fund Transfer" ||
      receiptData.receiptType === "UPI"
    ) {
      receiptData.cashHandleCharge = 0;
      receiptData.chequeDate = null;
    } else if (receiptData.receiptType === "CASH") {
      receiptData.chequeDate = null;
    } else if (receiptData.receiptType === "CHEQUE") {
      receiptData.cashHandleCharge = 0;
    }

    // override the application to save multiple receords to hdr table.
    // since customer id not empty for application mode.
    // and application number should not be empty for customer mode save.
    // reset first.
    receiptData.applicationNum = [];
    const appNums = [
      ...receiptData.favourList.map((row) => row.applicationNum),
    ];
    receiptData.applicationNum = [...new Set(appNums)];

    // merge normal data & prepay object.
    let prepayDetailsData = store.getState().fileReceiptGrid.prePayDetails;
    receiptData.prepayReceiptMode =
      store.getState().fileReceiptGrid.prepayReceiptMode;
    receiptData = { ...receiptData, ...prepayDetailsData };
    return receiptData;
  };

  //validation disbursement status
  const validateDisbursementStatus = async(receiptData) =>{
    //In create mode application num is string but in modify mode it is array
    //Hence this change added
    let appNum = receiptData.applicationNum
    if(typeof appNum==="string"){
      appNum = [appNum]
    }
    const params = {
      "applicationNumber":appNum
      }
    try {
      let data;
      const response = await axios.post(
        "disbursement/validateDisbursementStatus",
        params
      );
      if (response.data) {
        data = response.data
      }
      return data;
    } catch(error) {
      setAlertType("error");
      setMessage(error.message);
      openAlertHandler();
      setSaveRequestActiveSpinnerMsg("");
      dispatch(FileReceiptGridReducerAction.updateSaveRequestActive(false));
      throw new Error("Network error")
    }
  }

  const SendData = async () => {
    dispatch(FileReceiptGridReducerAction.updateSaveRequestActive(true));
    setSaveRequestActiveSpinnerMsg(
      "Preparing File Receipt Data for server Request ..."
    );
    let receiptData = await saveRequestPayloadFormation();
    // since it's neft type we override the below fields.
    // setSaveRequestActiveSpinnerMsg(
    //   "Transferring the data for AML Rules Validation ...."
    // );
    // setTimeout(async () => {
    //   await validationOfAMLRules(receiptData);
    // }, 1500);

    //For now skipped AML validation initiating file reciept save 22-10-2024
    //need to include in future build
    setSaveRequestActiveSpinnerMsg("Initiating File Receipt Save ....");
      setTimeout(async () => {
        await fileReceiptDataSave(receiptData);
      }, 1500);
  };

  const validationOfAMLRules = async (receiptData) => {
    try {
      const response = await axios.post(
        "/filereceipt/checkAmlRules",
        receiptData
      );
      const amlResponseData = response.data;
      if (amlResponseData.status === 1) {
        if (
          amlResponseData.errMessage &&
          String(amlResponseData.errMessage).length > 0
        ) {
          // in this case get the file upload using dialog from user & then proceed for save.
          dispatch(FileReceiptGridReducerAction.updateSaveRequestActive(false));
          setSaveRequestActiveSpinnerMsg("");
          setAlertType("error");
          setMessage(amlResponseData.errMessage);
          openAlertHandler();
          setAmlFileUploadAreaOpen(true);
        } else {
          // indicates the success & no error message, proceed the request to save API call.
          setSaveRequestActiveSpinnerMsg("Initiating File Receipt Save ....");
          setTimeout(async () => {
            await fileReceiptDataSave(receiptData);
          }, 1500);
        }
      } else {
        // status is -1 means some error or internal server error on web api side.
        setAlertType("error");
        setMessage(amlResponseData.errMessage);
        openAlertHandler();
        setSaveRequestActiveSpinnerMsg("");
        dispatch(FileReceiptGridReducerAction.updateSaveRequestActive(false));
      }
    } catch (error) {
      console.log(error);
      setAlertType("error");
      setMessage(error.message);
      openAlertHandler();
      setSaveRequestActiveSpinnerMsg("");
      dispatch(FileReceiptGridReducerAction.updateSaveRequestActive(false));
      throw Error(error);
    }
  };

  const reformDataForReceiptSaveWithUploadedAMLFiles = async () => {
    // from file upload area store get the latest uploaded files.
    const activeFileUploadedArea =
      store.getState().fileUploadAreaAndPreview.activeFileUploadAreaData;
    if (activeFileUploadedArea.uploadAreaFiles.length > 1) {
      // can't proceed more than 1 file then stay on dialog
      setAlertType("error");
      setMessage("Aml Uploaded Files Count Can't be greater than 1");
      openAlertHandler();
      setSaveRequestActiveSpinnerMsg("");
      dispatch(FileReceiptGridReducerAction.updateSaveRequestActive(false));
      return;
    }
    setSaveRequestActiveSpinnerMsg("Initiating File Receipt Save .... ");
    try {
      const files = [];
      for (const file of activeFileUploadedArea.uploadAreaFiles) {
        const blob = await convertFileToBlob(file);
        let newFile = { name: file.name, dataBlob: blob };
        files.push(newFile);
      }
      let receiptData = await saveRequestPayloadFormation();
      receiptData.documentData = files;
      await fileReceiptDataSave(receiptData);
      setAmlFileUploadAreaOpen(false);
    } catch (error) {
      console.log(error);
      // in case error stay on the AML dialog as open.
      setAlertType("error");
      setMessage(error.message);
      openAlertHandler();
      setSaveRequestActiveSpinnerMsg("");
      dispatch(FileReceiptGridReducerAction.updateSaveRequestActive(false));
    }
  };

  const convertFileToBlob = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        resolve(event.target && event.target.result);
      };
      reader.readAsDataURL(file);
    });
  };

  const fileReceiptDataSave = async (receiptData) => {
    setSaveRequestActiveSpinnerMsg("Processing File Receipt Save ....");
    try {
      const response = await axios.post(
        "/filereceipt/insertFileReceipt",
        receiptData
      );
      const responseReceiptData = response.data;
      if (responseReceiptData.voucherSeqGenerated) {
        setSaveRequestActiveSpinnerMsg(
          props.screenMode === "CREATE"
            ? `File Receipt Saved Successfully ......`
            : `File Receipt Updated Successfully .....`
        );
        setTimeout(() => {
          setSaveRequestActiveSpinnerMsg("");
          dispatch(FileReceiptGridReducerAction.updateSaveRequestActive(false));
          if (props.screenMode === "CREATE") {
            setDialogConfirmMode(false);
            setDialogTitleMessage("Information");
            setDialogMessage(
              `File Receipt Saved Successfully. Voucher Number : ` +
                responseReceiptData.receiptData.voucherNum
            );
            handleClickOpen();
            setMessage("Receipt Saved Successfully.");
          } else {
            setDialogConfirmMode(false);
            setDialogTitleMessage("Information");
            setDialogMessage(`File Receipt Updated Successfully.`);
            handleClickOpen();
            setMessage("Receipt Updated Successfully.");
          }
          setAlertType("success");
          openAlertHandler();
          dispatch(
            FileReceiptGridReducerAction.updateThirdPartDisplayFlag(false)
          );
          dispatch(FileReceiptGridReducerAction.updateSaveDone(true));
        }, 1000);
      } else if (responseReceiptData.prepaymentExceeded) {
        setDialogConfirmMode(false);
        setDialogTitleMessage("Information");
        setDialogMessage(
          `Not able to save details, Prepayment Receipt amount Exceeds principle amount.`
        );
        setSaveRequestActiveSpinnerMsg("");
        dispatch(FileReceiptGridReducerAction.updateSaveRequestActive(false));
        handleClickOpen();
      } else if (responseReceiptData.notApprovedAppNumPresent) {
        setDialogConfirmMode(false);
        setDialogTitleMessage("Information");
        setDialogMessage(
          `Not able to save prepay details, since one of the application is not approved.`
        );
        setSaveRequestActiveSpinnerMsg("");
        dispatch(FileReceiptGridReducerAction.updateSaveRequestActive(false));
        handleClickOpen();
      } else {
        setDialogConfirmMode(false);
        setDialogTitleMessage("Information");
        setDialogMessage(
          `Not able to save details, Receipt Sequence Generation value not available.`
        );
        setSaveRequestActiveSpinnerMsg("");
        dispatch(FileReceiptGridReducerAction.updateSaveRequestActive(false));
        handleClickOpen();
      }
    } catch (error) {
      console.log(error);
      setAlertType("error");
      setMessage("Receipt Save Failed.");
      openAlertHandler();
      setSaveRequestActiveSpinnerMsg("");
      dispatch(FileReceiptGridReducerAction.updateSaveRequestActive(false));
      throw Error(error);
    }
  };

  return (
    <React.Fragment>
      <Box
        sx={{
          float: "left",
          margin: "16px 8px 8px 8px",
          display: "inline-flex",
        }}
      >
        {props.fileReceiptState.receiptType === "CASH" && (
          <Grid item xs={12} sm={6} md={4} lg={2} xl={3}>
            <label
              style={{
                fontWeight: "bold",
                marginLeft: "8px",
                color: "#2F7DC4",
                marginRight: "8px",
              }}
            >
              {"Receipt Amount (₹) : "}
              <span style={{ color: "#2F7DC4" }}>
                {parseInt(props.fileReceiptState.receiptAmt).toLocaleString(
                  "en-IN"
                )}
              </span>
              {``}
            </label>
          </Grid>
        )}
        {props.fileReceiptState.receiptType === "CASH" && (
          <Grid item xs={12} sm={6} md={4} lg={2} xl={3}>
            <label
              style={{
                fontWeight: "bold",
                marginLeft: "8px",
                color: "#2F7DC4",
                marginRight: "8px",
              }}
            >
              {"Cash Handling Charges (₹) : "}
              <span style={{ color: "#2F7DC4" }}>
                {parseInt(
                  props.fileReceiptState.cashHandleCharge
                ).toLocaleString("en-IN")}
              </span>
              {``}
            </label>
          </Grid>
        )}
        <Grid item xs={12} sm={6} md={4} lg={2} xl={3}>
          <label
            style={{
              fontWeight: "bold",
              marginLeft: "8px",
              color: "#2F7DC4",
              marginRight: "8px",
            }}
          >
            {"Total Receipt Amount (₹) : "}
            <span style={{ color: "#2F7DC4" }}>
              {parseInt(props.fileReceiptState.totalReceiptAmt).toLocaleString(
                "en-IN"
              )}
            </span>
            {``}
          </label>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={2} xl={3}>
          <label
            style={{
              fontWeight: "bold",
              marginLeft: "8px",
              color: "#2F7DC4",
              marginRight: "8px",
            }}
          >
            {"Remaining Amount (₹) : "}
            <span style={{ color: "#2F7DC4" }}>
              {(
                parseInt(props.fileReceiptState.totalReceiptAmt) -
                parseInt(store.getState().fileReceiptGrid.remainingCreditAmt)
              ).toLocaleString("en-IN")}
            </span>
            {``}
          </label>
        </Grid>
      </Box>
      <Box sx={{ float: "right", margin: "8px 0px 8px 0px" }}>
        <Tooltip title="Ctrl+Z" placement="top">
          <Button
            size="small"
            sx={{ margin: "8px" }}
            variant="contained"
            type="submit"
            disabled={saveRequestActive}
            onClick={() => {
              props.handleTabChange("1");
            }}
            ref={backRef}
          >
            Back
          </Button>
        </Tooltip>

        {props.screenMode !== "VIEW" && (
          <Tooltip title="Ctrl+S" placement="top">
            <Button
              size="small"
              sx={{ margin: "8px" }}
              variant="contained"
              type="submit"
              onClick={() => {
                setTimeout(() => {
                  onSaveBtnClickHandler();
                }, 1500);
              }}
              disabled={
                [...datarows].length === 0 ||
                voucherDateValidDateError ||
                saveRequestActive ||
                deleteOperationActive
              }
              ref={saveRef}
            >
              Save
            </Button>
          </Tooltip>
        )}

        {props.screenMode !== "VIEW" && (
          <Tooltip title="Ctrl+A">
            <Button
              size="small"
              sx={{ margin: "8px" }}
              variant="contained"
              disabled={
                props.screenMode === "VIEW" ||
                deleteOperationActive ||
                saveRequestActive
              }
              onClick={() => {
                gridRowAddButtonHandler();
              }}
              ref={addRowRef}
            >
              <Add fontSize="small" />
            </Button>
          </Tooltip>
        )}
      </Box>
      {saveRequestActive && (
        <>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                alignItems: "center",
              }}
            >
              <CircularProgress color="inherit" />
              <p>{saveRequestActiveSpinnerMsg}</p>
            </Box>
          </Backdrop>
        </>
      )}
      {useMediaQuery("(min-width:1200px)") && (
        <CustomDataGrid
          noDataMessage="No Data."
          noDataOnFilterMessage="No Data on Applied Filter."
          rows={datarows}
          gridHeight={
            window.innerHeight > 650 ? window.innerHeight / 2 : "260px"
          }
          columns={gridColumns}
          pageSize={10}
          isCellEditable={() => true}
          pageSizeOptions={[10]}
          onCellEditCommit={(params) => {
            cellChangeHandler(params);
          }}
          onCellKeyDown={(params, event) => {
            (event.key === "e" ||
              event.key === "E" ||
              event.key === "." ||
              event.key.includes("-")) &&
              event.preventDefault();
            handleOnCellKeyDown(params, event);
          }}
          onCellDoubleClick={(params) => {
            cellDoubleClickHandler(params);
          }}
          loading={deleteOperationActive}
          gridLazyLoad={() => {}}
          onSortModelChange={() => {}}
        />
      )}
      {useMediaQuery("(max-width:1200px)") && (
        <Paper sx={{ marginBottom: "8px", padding: "0px 16px 8px 16px" }}>
          <React.Fragment>
            <Grid
              container
              item
              direction="row"
              alignItems="flex-end"
              justifyContent="flex-end"
              sx={{ height: "60px", bgcolor: "white" }}
            >
              {totalRowsCount > 10 && (
                <Typography
                  sx={{
                    mr: 2,
                    color: "#004A92",
                    fontWeight: 700,
                  }}
                >
                  {"Page Max Records : " + rowsPerPage}
                </Typography>
              )}
              <Typography
                padding="1px"
                sx={{
                  color: "#004A92",
                  fontWeight: 700,
                }}
              >
                {"Total Records : " + totalRowsCount}
              </Typography>
              <Pagination
                count={totalPageCount}
                color="primary"
                onChange={handlePageChange}
                page={page}
                renderItem={(item) => (
                  <PaginationItem
                    slots={{ previous: ArrowBack, next: ArrowForward }}
                    {...item}
                  />
                )}
              />
            </Grid>
            <Grid container>
              <Box
                sx={{
                  height: accordianOpen
                    ? window.innerHeight - 540
                    : window.innerHeight - 250,
                  overflow: "auto",
                  flex: "1 auto",
                  marginBottom: "16px",
                }}
              >
                {rows.map((row, index) => (
                  <React.Fragment>
                    <Grid container direction="column" sx={{ flex: "1 auto" }}>
                      <Card>
                        <CardHeader
                          subheader={
                            props.fileReceiptState.receiptFor ===
                            "Application Number"
                              ? "Branch - GLAcc : " +
                                row.branch +
                                " - " +
                                row.glAcc
                              : "Branch - AppNum - GLAcc : " +
                                row.branch +
                                " - " +
                                row.applicationNum +
                                " - " +
                                row.glAcc
                          }
                          subheaderTypographyProps={{
                            color: "#004A92",
                            fontWeight: "700",
                          }}
                          action={
                            <React.Fragment>
                              {props.screenMode !== "VIEW" && (
                                <Tooltip title="Delete" placement="top">
                                  <IconButton size="small">
                                    <Delete
                                      fontSize="small"
                                      sx={{ color: "#004A92", fontWeight: 700 }}
                                      onClick={() => {
                                        let params = {
                                          id: row.id,
                                        };
                                        deleteSelectedRow(params);
                                      }}
                                    />
                                  </IconButton>
                                </Tooltip>
                              )}
                            </React.Fragment>
                          }
                          sx={{
                            textAlign: "left",
                            padding: "16px 16px 0px 16px !important",
                          }}
                        />
                        <CardContent sx={{}}>
                          <Grid
                            container
                            item
                            direction="column"
                            alignItems="flex-start"
                            justifyContent="flex-start"
                            sx={{}}
                          >
                            <Grid
                              container
                              direction="row"
                              alignItems="flex-start"
                              justifyContent="flex-start"
                            >
                              {props.fileReceiptState.receiptFor ===
                                "Application Number" && (
                                <React.Fragment>
                                  <Grid item xs={7} md={5}>
                                    <Typography padding="1px">
                                      {"Branch"}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={5} md={7}>
                                    {` :  ${row.branch}`}
                                  </Grid>
                                  <Grid item xs={7} md={5}>
                                    <Typography padding="1px">
                                      {"Application Number"}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={5} md={7}>
                                    {` :  ${row.applicationNum}`}
                                  </Grid>
                                  <Grid item xs={7} md={5}>
                                    <Typography padding="1px">
                                      {"GL Account"}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={5} md={7}>
                                    <span
                                      style={{
                                        display: "flex",
                                      }}
                                    >
                                      {` : `}
                                      {props.screenMode !== "VIEW" && (
                                        <CustomAutoComplete
                                          variant="standard"
                                          type="text"
                                          disabled={props.screenMode === "VIEW"}
                                          placeholder="Select Gl Account"
                                          autoCompleteValues={currentRowGlAccounts.map(
                                            (record) =>
                                              record.account_head +
                                              " - " +
                                              record.account_desc
                                          )}
                                          value={row.glAcc}
                                          onChange={(e, value) => {
                                            let params = {
                                              id: row.id,
                                              field: "glAcc",
                                              value: value,
                                            };
                                            cellChangeHandler(params);
                                          }}
                                        />
                                      )}
                                      {props.screenMode === "VIEW" && (
                                        <React.Fragment>
                                          {row.glAcc}
                                        </React.Fragment>
                                      )}
                                    </span>
                                  </Grid>
                                  <Grid item xs={7} md={5}>
                                    <Typography padding="1px">
                                      {"Gl Account Desc"}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={5} md={7}>
                                    {` :  ${
                                      row.glAccDesc !== null &&
                                      row.glAccDesc !== undefined &&
                                      row.glAccDesc !== ""
                                        ? row.glAccDesc
                                        : "-----------------------"
                                    }`}
                                  </Grid>
                                  <Grid item xs={7} md={5}>
                                    <Typography padding="1px">
                                      {"Credit Amount"}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={5} md={7}>
                                    {` : `}
                                    {props.screenMode !== "VIEW" && (
                                      <TextField
                                        autoComplete="off"
                                        sx={{
                                          "& .MuiInputBase-input": {
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                          },
                                        }}
                                        inputProps={{
                                          inputMode: "numeric",
                                          pattern: "[0-9]*",
                                          style: {
                                            textAlign: `left`,
                                            fontSize: "12px",
                                          },
                                        }}
                                        type="number"
                                        variant="standard"
                                        value={row.creditAmt}
                                        placeholder="Please Enter Credit Amount"
                                        disabled={props.screenMode === "VIEW"}
                                        onChange={(event) => {
                                          let params = {
                                            id: row.id,
                                            field: "creditAmt",
                                            value: event.target.value,
                                          };
                                          cellChangeHandler(params);
                                        }}
                                        onBlur={() => {}}
                                        onKeyDown={(e) => {
                                          if (
                                            e.key === "e" ||
                                            e.key === "E" ||
                                            e.key === "-" ||
                                            e.key === "+"
                                          ) {
                                            e.preventDefault();
                                          }
                                        }}
                                      />
                                    )}
                                    {props.screenMode === "VIEW" && (
                                      <React.Fragment>
                                        {parseInt(row.creditAmt).toLocaleString(
                                          "en-IN"
                                        )}
                                      </React.Fragment>
                                    )}
                                  </Grid>
                                </React.Fragment>
                              )}
                              {props.fileReceiptState.receiptFor ===
                                "Customer ID" && (
                                <React.Fragment>
                                  <Grid item xs={7} md={5}>
                                    <Typography padding="1px">
                                      {"Branch"}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={5} md={7}>
                                    <span
                                      style={{
                                        display: "flex",
                                      }}
                                    >
                                      {` : `}
                                      {props.screenMode !== "VIEW" && (
                                        <CustomAutoComplete
                                          variant="standard"
                                          type="text"
                                          disabled={props.screenMode === "VIEW"}
                                          placeholder="Select Branch"
                                          autoCompleteValues={[
                                            ...props.appNumByCustIdBranch,
                                          ].map((record) => record.branch)}
                                          value={row.branch}
                                          onChange={(e, value) => {
                                            let params = {
                                              id: row.id,
                                              field: "branch",
                                              value: value,
                                            };
                                            cellChangeHandler(params);
                                          }}
                                        />
                                      )}
                                      {props.screenMode === "VIEW" && (
                                        <React.Fragment>
                                          {row.branch}
                                        </React.Fragment>
                                      )}
                                    </span>
                                  </Grid>
                                  <Grid item xs={7} md={5}>
                                    <Typography padding="1px">
                                      {"Application Number"}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={5} md={7}>
                                    <span
                                      style={{
                                        display: "flex",
                                      }}
                                    >
                                      {` : `}
                                      {props.screenMode !== "VIEW" && (
                                        <CustomAutoComplete
                                          variant="standard"
                                          type="text"
                                          disabled={props.screenMode === "VIEW"}
                                          placeholder="Select Application Number"
                                          autoCompleteValues={
                                            currentRowAppNumsArray
                                          }
                                          value={row.applicationNum}
                                          onOpen={() => {
                                            let params = {
                                              id: row.id,
                                              field: "applicationNum",
                                            };
                                            cellDoubleClickHandler(params);
                                          }}
                                          onChange={(e, value) => {
                                            let params = {
                                              id: row.id,
                                              field: "applicationNum",
                                              value: value,
                                            };
                                            cellChangeHandler(params);
                                          }}
                                        />
                                      )}
                                      {props.screenMode === "VIEW" && (
                                        <React.Fragment>
                                          {row.applicationNum}
                                        </React.Fragment>
                                      )}
                                    </span>
                                  </Grid>
                                  <Grid item xs={7} md={5}>
                                    <Typography padding="1px">
                                      {"GL Account"}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={5} md={7}>
                                    <span
                                      style={{
                                        display: "flex",
                                      }}
                                    >
                                      {` : `}
                                      {props.screenMode !== "VIEW" && (
                                        <CustomAutoComplete
                                          variant="standard"
                                          type="text"
                                          disabled={props.screenMode === "VIEW"}
                                          placeholder="Select Gl Account"
                                          autoCompleteValues={currentRowGlAccounts.map(
                                            (record) =>
                                              record.account_head +
                                              " - " +
                                              record.account_desc
                                          )}
                                          value={row.glAcc}
                                          onOpen={() => {
                                            let params = {
                                              id: row.id,
                                              field: "glAcc",
                                            };
                                            cellDoubleClickHandler(params);
                                          }}
                                          onChange={(e, value) => {
                                            let params = {
                                              id: row.id,
                                              field: "glAcc",
                                              value: value,
                                            };
                                            cellChangeHandler(params);
                                          }}
                                        />
                                      )}
                                      {props.screenMode === "VIEW" && (
                                        <React.Fragment>
                                          {row.glAcc}
                                        </React.Fragment>
                                      )}
                                    </span>
                                  </Grid>
                                  <Grid item xs={7} md={5}>
                                    <Typography padding="1px">
                                      {"Gl Account Desc"}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={5} md={7}>
                                    {` :  ${
                                      row.glAccDesc !== null &&
                                      row.glAccDesc !== undefined &&
                                      row.glAccDesc !== ""
                                        ? row.glAccDesc
                                        : "-----------------------"
                                    }`}
                                  </Grid>
                                  <Grid item xs={7} md={5}>
                                    <Typography padding="1px">
                                      {"Credit Amount"}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={5} md={7}>
                                    {` : `}
                                    {props.screenMode !== "VIEW" && (
                                      <TextField
                                        autoComplete="off"
                                        sx={{
                                          "& .MuiInputBase-input": {
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                          },
                                        }}
                                        inputProps={{
                                          inputMode: "numeric",
                                          pattern: "[0-9]*",
                                          style: {
                                            textAlign: `left`,
                                            fontSize: "12px",
                                          },
                                        }}
                                        type="number"
                                        variant="standard"
                                        value={row.creditAmt}
                                        placeholder="Please Enter Credit Amount"
                                        disabled={props.screenMode === "VIEW"}
                                        onChange={(event) => {
                                          let params = {
                                            id: row.id,
                                            field: "creditAmt",
                                            value: event.target.value,
                                          };
                                          cellChangeHandler(params);
                                        }}
                                        onBlur={() => {}}
                                        onKeyDown={(e) => {
                                          if (
                                            e.key === "e" ||
                                            e.key === "E" ||
                                            e.key === "-" ||
                                            e.key === "+"
                                          ) {
                                            e.preventDefault();
                                          }
                                        }}
                                      />
                                    )}
                                    {props.screenMode === "VIEW" && (
                                      <React.Fragment>
                                        {parseInt(row.creditAmt).toLocaleString(
                                          "en-IN"
                                        )}
                                      </React.Fragment>
                                    )}
                                  </Grid>
                                </React.Fragment>
                              )}
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                    <Divider />
                  </React.Fragment>
                ))}
                {rows.length === 0 && (
                  <NoDataFound
                    message={"No Data Found."}
                    imageStyle={{
                      marginTop:
                        accordianOpen && window.innerHeight < 1000
                          ? "20px"
                          : "20%",
                    }}
                  />
                )}
              </Box>
            </Grid>
          </React.Fragment>
        </Paper>
      )}
      <Snackbar
        open={alert}
        autoHideDuration={6000}
        anchorOrigin={{ vertical, horizontal }}
        onClose={closeAlertHandler}
      >
        <Alert
          onClose={closeAlertHandler}
          severity={alertType}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
      <Dialog open={open} aria-describedby="alert-dialog-slide-description">
        <DialogTitle>{dialogTitleMessage}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {dialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {dialogConfirmMode && (
            <Tooltip title="Ctrl+Q">
              <Button
                onClick={() => {
                  setOpen(false);
                  handleClose();
                }}
                ref={cancelRef}
              >
                Cancel
              </Button>
            </Tooltip>
          )}
          <Tooltip
            title={dialogConfirmMode ? "Ctrl+Y" : "Ctrl+K"}
            placement="top"
          >
            <Button onClick={handleOk} ref={dialogConfirmMode ? yesRef : okRef}>
              {dialogConfirmMode ? "Yes" : "Ok"}
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>

      <Dialog
        open={AmlFileUploadAreaOpen}
        fullScreen={true}
        aria-describedby="alert-dialog-slide-description"
      >
        <Paper>
          <DialogTitle>{"AML File Upload Area"}</DialogTitle>
          <DialogContent>
            <h4>{"AML File Upload Area"}</h4>
            {<FileUploadAreaAndPreview {...fileUploadAreaProps} />}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                // on close discard the uplaoded area files & close the aml upload area dlg.
                dispatch(
                  FileUploadAreaAndPreviewReducerAction.resetToInitialState()
                );
                setAmlFileUploadAreaOpen(false);
              }}
            >
              Close
            </Button>
            <Button
              onClick={() => {
                // reform the data and proceed to receipt save.
                setSaveRequestActiveSpinnerMsg(
                  "Validating AML uploaded Files count ...."
                );
                dispatch(
                  FileReceiptGridReducerAction.updateSaveRequestActive(true)
                );
                setTimeout(() => {
                  reformDataForReceiptSaveWithUploadedAMLFiles();
                }, 1500);
              }}
            >
              Ok
            </Button>
          </DialogActions>
        </Paper>
      </Dialog>
    </React.Fragment>
  );
};

export default CreditAmountDetails;
